import { Assets, type Texture } from 'pixi.js';
import oneUpUrl from '../assets/bonus/one-up.svg';
import blockGemUrl from '../assets/totems/block-gem.png';
import orangeBodyUrl from '../assets/totems/orange-body.png';
import orbOffUrl from '../assets/totems/orb-off.png';
import orbOrangeUrl from '../assets/totems/orb-orange.png';
import orbTurquoiseUrl from '../assets/totems/orb-turquoise.png';
import turquoiseBodyUrl from '../assets/totems/turquoise-body.png';

export type TotemCamp = 'ORANGE' | 'TURQUOISE';

export type TotemArt = {
  body: Texture;
  orbOn: Texture;
  orbOff: Texture;
};

let packs: Record<TotemCamp, TotemArt> | null = null;
let blockTex: Texture | null = null;
let oneUpTex: Texture | null = null;

function prepare(texture: Texture): Texture {
  texture.source.scaleMode = 'linear';
  texture.source.autoGenerateMipmaps = true;
  texture.source.addressMode = 'clamp-to-edge';
  return texture;
}

export async function loadTotemArt(): Promise<void> {
  if (packs && blockTex && oneUpTex) return;
  const [orangeBody, turquoiseBody, orbOrange, orbTurquoise, orbOff, block, oneUp] =
    await Promise.all([
      Assets.load<Texture>(orangeBodyUrl),
      Assets.load<Texture>(turquoiseBodyUrl),
      Assets.load<Texture>(orbOrangeUrl),
      Assets.load<Texture>(orbTurquoiseUrl),
      Assets.load<Texture>(orbOffUrl),
      Assets.load<Texture>(blockGemUrl),
      Assets.load<Texture>({ src: oneUpUrl, data: { resolution: 2 } }),
    ]);
  packs = {
    ORANGE: {
      body: prepare(orangeBody),
      orbOn: prepare(orbOrange),
      orbOff: prepare(orbOff),
    },
    TURQUOISE: {
      body: prepare(turquoiseBody),
      orbOn: prepare(orbTurquoise),
      orbOff: prepare(orbOff),
    },
  };
  blockTex = prepare(block);
  oneUpTex = prepare(oneUp);
}

export function peekTotemArt(camp: TotemCamp): TotemArt | null {
  return packs?.[camp] ?? null;
}

export function peekBlockArt(): Texture | null {
  return blockTex;
}

export function peekOneUpArt(): Texture | null {
  return oneUpTex;
}
